import moment from "moment";

import type { ReminderLeadIds, ReminderLeads } from "../types";

export type ReminderBucket = "today" | "overdue" | "upcoming";

const pickField = (obj: any, keys: string[]): string | undefined => {
  if (!obj) return undefined;
  for (const k of keys) {
    const v = obj[k];
    if (v !== undefined && v !== null && String(v).trim() !== "") return String(v);
  }
  return undefined;
};

export const getLeadCity = (lead: any): string | undefined =>
  pickField(lead?.response, ["City", "city", "CITY", "Town", "town"]);

export const getLeadState = (lead: any): string | undefined =>
  pickField(lead?.response, ["State", "state", "STATE"]);

/**
 * Build reminder buckets directly from a given set of leads (e.g. the
 * "transfer from" employee's leads). This keeps the reminders filter scoped
 * to the selected employee and avoids the slow form-wide reminders API.
 */
export const computeReminderBuckets = (
  leads: any[],
): { ids: ReminderLeadIds; leads: ReminderLeads } => {
  const ids: ReminderLeadIds = { today: [], overdue: [], upcoming: [] };
  const items: ReminderLeads = { today: [], overdue: [], upcoming: [] };
  const start = moment().startOf("day");

  (leads || []).forEach((lead) => {
    if (!lead?.follow_up_date) return;
    const d = moment(lead.follow_up_date);
    if (!d.isValid()) return;
    const day = d.clone().startOf("day");
    let bucket: ReminderBucket;
    if (day.isSame(start, "day")) bucket = "today";
    else if (day.isBefore(start, "day")) bucket = "overdue";
    else bucket = "upcoming";
    ids[bucket].push(Number(lead.key));
    items[bucket].push(lead);
  });

  return { ids, leads: items };
};
